import React, { useState, useMemo, useEffect, useRef, useCallback } from 'react';
// import LayoutMain_Bus from "../LayoutMain_Bus/LayoutMain_Bus";
import styles from './MileageSaarathi.module.css';
import * as $ from 'jquery';
import 'daterangepicker'; // JS
import 'daterangepicker/daterangepicker.css';
import FleetEnergyChart from './FleetEnergyEffGraph';
import Filter_bus from "./Filter/Filter_Bus"
import { decodeToken } from 'react-jwt';
import { API_URL_MAIN, INIT_FILTER_STATE_MILEAGE_SAARATHI } from '../../../../constants/driveglobalfilterinitalstates_bus';
import InsightsTable from './FleetInsights';
import VehicleTable from './BestVehiclesTable';
import FleetLevelSummaryTable from './FleetLevelSummaryTable';
import FaultIncidentTable from './FaultIncidentTable';
import DrivingBehaviorTable from './DrivingBehaviorTable';
import ServiceSummaryTable from './ServiceSummaryTable';
import "../style.css"
import FleetSummary from './FleetSummary';

function Mileagesaarathi_two() {

  const tokenNew = JSON.parse(sessionStorage.user);
  let decodedToken = decodeToken(tokenNew.token);
  const city_name = decodedToken.city_name;
  const city_name_arr = city_name.split(",");
  const depo_name = decodedToken.depo_name;
  const depo_name_arr = depo_name.split(",");
  let sampleObj = (city_name != "") ? { ...INIT_FILTER_STATE_MILEAGE_SAARATHI, CITY: city_name_arr, DEPO: depo_name_arr } : INIT_FILTER_STATE_MILEAGE_SAARATHI
  const [globalFilter, setGlobalFilter] = useState({ ...sampleObj })

  const [activeDefaultTab, setActiveDefaultTab] = useState('Insights');
  const [activeInsightTab, setActiveInsightTab] = useState('Fault/Incidents');
  const [FleetInsightsLoading, setFleetInsightLoading] = useState(true)
  const [expertInsightsLoading, setExpertInsightLoading] = useState(true)
  const [activeCommunityTab, setActiveCommunityTab] = useState("community");


  const insightsRef = useRef();
  const bestRef = useRef();
  const focusRef = useRef();

  const faultIncidentRef = useRef();
  const drivingBehaviorRef = useRef();
  const serviceSummaryRef = useRef();

  const filterHideShow = () => {
    $("#filterSearch").toggle("slow");
  }

  const handleDownload = () => {
    if (activeDefaultTab === 'Insights') {
      insightsRef.current?.downloadData();
    } else if (activeDefaultTab === 'Best Vehicles') {
      bestRef.current?.downloadData();
    } else if (activeDefaultTab === 'Focus Vehicles') {
      focusRef.current?.downloadData();
    }
  };

  const handleDownloadForExpertInsights = () => {
    if (activeInsightTab === 'Fault/Incidents') {
      faultIncidentRef.current?.downloadData();
    } else if (activeInsightTab === 'Driving Behavior') {
      drivingBehaviorRef.current?.downloadData();
    } else if (activeInsightTab === 'Service Summary') {
      serviceSummaryRef.current?.downloadData();
    }
  };

  const filterSubmitted = useCallback((data) => {
    setGlobalFilter(data);
  }, []);


  return (
    <div className={` ${styles.sections_outline}`}>
      <Filter_bus onsubmit={filterSubmitted} setGlobalFilter={setGlobalFilter} gloablfilter={{ ...globalFilter }} setGloablfilter={setGlobalFilter} />
      <div className="card mb-3 p-3">
        <FleetSummary filterdata={globalFilter} setGloablfilter={setGlobalFilter} />
      </div>
      <div>
        <FleetEnergyChart filterdata={globalFilter} />
      </div>
      <div className="card mb-3 p-3">
        <FleetLevelSummaryTable filterdata={globalFilter} />
        <div className="mb-3 p-3">
          <div className="d-flex justify-content-between align-items-center mb-3">
            <div className="d-flex align-items-center">
              <h6 className="m-0 fw-bold me-2" onClick={() => setActiveDefaultTab('Insights')} style={{ cursor: 'pointer', color: activeDefaultTab === 'Insights' ? '#67a4b0' : 'inherit' }}>Insights</h6>
              <InfoIcon tooltipText="Insights about your fleet" />
              <span className="ms-3 fw-bold" onClick={() => setActiveDefaultTab('Best Vehicles')} style={{ cursor: 'pointer', color: activeDefaultTab === 'Best Vehicles' ? '#67a4b0' : 'inherit' }}>Best Vehicles</span>
              <InfoIcon tooltipText="Vehicles with best performance" />
              <span className="ms-3 fw-bold" onClick={() => setActiveDefaultTab('Focus Vehicles')} style={{ cursor: 'pointer', color: activeDefaultTab === 'Focus Vehicles' ? '#67a4b0' : 'inherit' }}>Focus Vehicles</span>
              <InfoIcon tooltipText="Vehicles that need attention" />
            </div>
            <a href="#" className={`text-decoration-none ${styles.download_button}  ${FleetInsightsLoading ? 'text-muted' : ""}`} style={{ pointerEvents: FleetInsightsLoading ? "none" : "" }} onClick={(e) => { e.preventDefault(); handleDownload(); }}><i className="fas fa-download me-1"></i>Download Report</a>
          </div>

         {/* Toggle ONLY when Insights is active */}
{activeDefaultTab === 'Insights' && (
  <div className="d-flex justify-content-between align-items-center mb-3 mt-2">

    <div className="btn-group" role="group" aria-label="Community/Fleet Toggle">
      {/* <input
        type="radio"
        className="btn-check"
        name="toggleGroup"
        id="communityToggle"
        autoComplete="off"
        defaultChecked
      />
      <label className="btn btn-outline-primary btn-sm" htmlFor="communityToggle">
        Community
      </label>

      <input
        type="radio"
        className="btn-check"
        name="toggleGroup"
        id="fleetToggle"
        autoComplete="off"
      />
      <label className="btn btn-outline-primary btn-sm" htmlFor="fleetToggle">
        Fleet
      </label> */}
      <input
  type="radio"
  className="btn-check"
  name="toggleGroup"
  id="communityToggle"
  autoComplete="off"
  defaultChecked
  onChange={() => setActiveCommunityTab("community")}
/>
<label className="btn btn-outline-primary btn-sm" htmlFor="communityToggle">
  Community
</label>

<input
  type="radio"
  className="btn-check"
  name="toggleGroup"
  id="fleetToggle"
  autoComplete="off"
  onChange={() => setActiveCommunityTab("fleet")}
/>
<label className="btn btn-outline-primary btn-sm" htmlFor="fleetToggle">
  Fleet
</label>

    </div>

  </div>
)}

{/* DISCLAIMER — show for ALL tabs */}
<div className="small text-muted mb-3 text-start">
  Disclaimer: Below value include the top & bottom 10 vehicles from the fleet
</div>

{/* INSIGHTS TABLE */}
{activeDefaultTab === 'Insights' && (
  <InsightsTable
    ref={insightsRef}
    filterdata={globalFilter}
    setFleetInsightLoading={setFleetInsightLoading}
    activeTab = {activeCommunityTab}
  
  />
)}

{/* BEST VEHICLES */}
{activeDefaultTab === 'Best Vehicles' && (
  <VehicleTable
    ref={bestRef}
    apiType="best"
    filterdata={globalFilter}
    setFleetInsightLoading={setFleetInsightLoading}
  />
)}

{/* FOCUS VEHICLES */}
{activeDefaultTab === 'Focus Vehicles' && (
  <VehicleTable
    ref={focusRef}
    apiType="focus"
    filterdata={globalFilter}
    setFleetInsightLoading={setFleetInsightLoading}
  />
)}

          <div className="mt-4 mb-3">
            <div className="d-flex justify-content-between align-items-center mb-3">
              <h6 className={`m-0 fw-bold ${styles.date_range_selection}`}>Expert Insights for Enhanced Profitability</h6>
              <a href="#" className={`text-decoration-none ${styles.download_button} ${expertInsightsLoading ? 'text-muted' : ""}`} style={{ pointerEvents: expertInsightsLoading ? "none" : "" }} onClick={(e) => { e.preventDefault(); handleDownloadForExpertInsights(); }}><i className="fas fa-download me-1"></i>Download Report</a>
            </div>

            <div className="row mb-3">
              <div className="col-md-12">
                <ul className="nav align-items-center">
                  {['Fault/Incidents', 'Driving Behavior', 'Service Summary'].map((tab) => (
                    <li className="nav-item me-4" key={tab}>
                      <span onClick={() => setActiveInsightTab(tab)} style={{ cursor: 'pointer', fontWeight: 'bold', color: activeInsightTab === tab ? '#358696' : 'black' }}>{tab}</span>
                    </li>
                  ))}
                  {activeInsightTab === 'Service Summary' ? (<div className="text-end ms-auto"><button type="button" id="filterIcon" onClick={filterHideShow} className={`btn btn-sm btn-sm ms_btn_ace material-icons  ${styles.btn_outline_primary_BDT}`}>filter_alt</button></div>) : <></>}
                </ul>
              </div>
            </div>

            {activeInsightTab === 'Fault/Incidents' && (<FaultIncidentTable filterdata={globalFilter} ref={faultIncidentRef} setExpertInsightLoading={setExpertInsightLoading} />)}
            {activeInsightTab === 'Driving Behavior' && (<DrivingBehaviorTable filterdata={globalFilter} ref={drivingBehaviorRef} setExpertInsightLoading={setExpertInsightLoading} />)}
            {activeInsightTab === 'Service Summary' && (<ServiceSummaryTable ref={serviceSummaryRef} setExpertInsightLoading={setExpertInsightLoading} filterdata={globalFilter} />)}

            <div className="card bg-light mt-3">
              <div className="card-body p-2">
                <div className="small text-start">
                  <p className="fw-bold mb-1">Disclaimer:</p>
                  <ul className="mb-0">
                    <li>Download reports are available for up to 20 vehicles only. Reports for more than 20 vehicles will be sent via email.</li>
                    <li>Energy Efficiency prediction is indicative in nature and depends on the combination of multiple factors. Improving one/more parameter{'(s)'} performance may or may not lead to guaranteed enhanced Energy Efficiency. </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  );
}

export default Mileagesaarathi_two;

const InfoIcon = ({ tooltipText }) => {
  const [showTooltip, setShowTooltip] = useState(false);

  return (
    <span
      style={{ position: 'relative', display: 'inline-block' }}
      onMouseEnter={() => setShowTooltip(true)}
      onMouseLeave={() => setShowTooltip(false)}
    >
      <i
        className={`fas fa-info-circle ${styles.summary_icons}`}
      ></i>

      {showTooltip && (
        <div
          style={{
            position: 'absolute',
            bottom: '125%',
            left: '50%',
            transform: 'translateX(-50%)',
            backgroundColor: '#fff',
            color: '#000',
            padding: '6px 10px',
            borderRadius: '4px',
            border: '1px solid #ccc',
            whiteSpace: 'nowrap',
            fontSize: '13px',
            boxShadow: '0px 2px 6px rgba(0, 0, 0, 0.2)',
            zIndex: 9999
          }}
        >
          {tooltipText}
        </div>
      )}
    </span>
  );
};
